import script from "./ScaledIframe.vue?vue&type=script&setup=true&lang=js"
export * from "./ScaledIframe.vue?vue&type=script&setup=true&lang=js"

import "./ScaledIframe.vue?vue&type=style&index=0&id=4c74958c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c74958c"]])

export default __exports__